import { useState } from "react";
import { X, Loader2, ShieldCheck, ExternalLink } from "lucide-react";
import { useDispatch } from "react-redux";
// Adjust this import path based on your folder structure
// import { initiateESign, verifyESign } from "../../../../../redux/reducers/letterHeadReducer";

export default function ESignModal({ onClose, onVerified }) {
  const [status, setStatus] = useState("idle");
  const dispatch = useDispatch();



  const handleDigiLockerSign = async () => {
    setStatus("processing");

    try {
      // Clean up old storage just in case
      localStorage.removeItem('DIGILOCKER_AUTH_CODE');
      localStorage.removeItem('DIGILOCKER_AUTH_ERROR');

      // 1. Get URL and Verifier from backend
      // const initRes = await dispatch(initiateESign()).unwrap(); 
      // const authUrl = initRes.url;
      // const codeVerifier = initRes.code_verifier;

      // 2. Open popup
      const width = 500;
      const height = 650;
      const left = window.screenX + (window.outerWidth - width) / 2;
      const top = window.screenY + (window.outerHeight - height) / 2;
      // const popup = window.open(authUrl, 'DigiLocker', `width=${width},height=${height},left=${left},top=${top}`);
      const popup = []

      // --- HELPER TO PROCESS THE VERIFICATION ---
      const processVerification = async (code) => {
         try {
            // const verifyRes = await dispatch(verifyESign({ code, code_verifier: codeVerifier })).unwrap();
            setStatus("success");
            setTimeout(() => {
                // onVerified({
                //     provider: verifyRes.provider,
                //     signerName: verifyRes.signerName,
                //     signedAt: verifyRes.signedAt,
                //     reference: verifyRes.transactionId,
                // });
                onClose();
            }, 1200);
         } catch (verifyErr) {
             setStatus("idle");
             alert("Verification failed. Please try again.");
         }
      };

      // --- LISTENER 1: postMessage ---
      const messageListener = (event) => {
        if (!event.data || !event.data.type || !event.data.type.startsWith('DIGILOCKER_')) return;
        window.removeEventListener('message', messageListener);
        if (popup && !popup.closed) popup.close();

        if (event.data.type === 'DIGILOCKER_SUCCESS') {
          processVerification(event.data.code);
        } else {
           setStatus("idle");
           alert("DigiLocker verification was cancelled.");
        }
      };
      window.addEventListener('message', messageListener);

      // --- LISTENER 2: LocalStorage (Bulletproof fallback) ---
      const storageListener = (event) => {
        if (event.key === 'DIGILOCKER_AUTH_CODE' && event.newValue) {
           window.removeEventListener('storage', storageListener);
           if (popup && !popup.closed) popup.close();
           processVerification(event.newValue);
           localStorage.removeItem('DIGILOCKER_AUTH_CODE'); // clean up
        } else if (event.key === 'DIGILOCKER_AUTH_ERROR' && event.newValue) {
           window.removeEventListener('storage', storageListener);
           if (popup && !popup.closed) popup.close();
           setStatus("idle");
           alert("DigiLocker verification was cancelled.");
           localStorage.removeItem('DIGILOCKER_AUTH_ERROR');
        }
      };
      window.addEventListener('storage', storageListener);

      // Failsafe if user manually clicks 'X' on the popup
      const timer = setInterval(() => {
        if (popup && popup.closed) {
          clearInterval(timer);
          window.removeEventListener('message', messageListener);
          window.removeEventListener('storage', storageListener);
          if (status !== "success") setStatus("idle");
        }
      }, 500);

    } catch (err) {
      console.error(err);
      setStatus("idle");
      alert("Failed to connect to DigiLocker servers.");
    }
  };
  
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-in fade-in duration-200">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-sm overflow-hidden text-center">

        {/* Header */}
        <div className="px-6 py-4 border-b border-slate-100 flex justify-between items-center bg-slate-50/50">
          <div className="flex items-center gap-2">
            <ShieldCheck className="text-blue-600" size={20} />
            <h3 className="font-bold text-lg text-slate-900">DigiLocker eSign</h3>
          </div>
          <button onClick={onClose} className="text-slate-400 hover:text-slate-600 transition-colors">
            <X size={20} />
          </button>
        </div>

        {/* Content */}
        <div className="p-8 flex flex-col items-center">

          {status === "idle" && (
            <>
              <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mb-4">
                <ShieldCheck size={32} className="text-blue-600" />
              </div>
              <p className="text-slate-600 text-sm mb-6">
                You will be redirected securely to DigiLocker (API Setu) to authenticate and sign this document.
              </p>
              <button
                onClick={handleDigiLockerSign}
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2.5 rounded-lg text-sm font-medium shadow-lg shadow-blue-200 transition-all flex items-center gap-2"
              >
                Proceed to DigiLocker <ExternalLink size={16} />
              </button>
            </>
          )}

          {status === "processing" && (
            <>
              <Loader2 size={40} className="animate-spin text-blue-600 mb-4" />
              <h4 className="font-bold text-slate-800 mb-1">Waiting for Signature...</h4>
              <p className="text-xs text-slate-500">Please complete the process in the secure popup window.</p>
            </>
          )}

          {status === "success" && (
            <>
              <div className="w-16 h-16 bg-green-50 rounded-full flex items-center justify-center mb-4 animate-in zoom-in">
                <ShieldCheck size={32} className="text-green-600" />
              </div>
              <h4 className="font-bold text-slate-800 mb-1">Signed Successfully!</h4>
              <p className="text-xs text-slate-500">Applying digital certificate...</p>
            </>
          )}

        </div>
      </div>
    </div>
  );
}

